import { HttpService } from "@/core";
import { ExportResp } from "@/core/interface";
import { PlanDetailResp, PlanImportResp, PlanReq } from "./plan-table.interface";
import store from "@/store"
export class PlanTableService {
  static usePlanCreateApi() {
    const api = (planId: string, data: PlanReq) =>
      HttpService.axios({
        method: "POST",
        url: `/project_work_plan/${planId}/detail`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static usePlanDetailApi() {
    const api = (planId: string,params?) =>
      HttpService.axios({
        method: "GET",
        url: `/project_work_plan/${planId}/detail`,
        params
      });
    return HttpService.useRequest<PlanDetailResp>(api);
  }
  static usePlanDetailApi2() {
    const api = ({ planId, name }) =>
      HttpService.axios({
        method: "GET",
        url: `/project_work_plan/${planId}/detail`,
        params: { name },
      });
    return HttpService.useRequest<PlanDetailResp>(api);
  }
  static usePlanDetailApi3() {
    const api = ({ planId, name='' }) =>
      HttpService.axios({
        method: "GET",
        url: `/project_work_budget_quantities/list?projectId=${planId}&validStatus=ysx`,
        params: { name },
      });
    return HttpService.useRequest<PlanDetailResp>(api);
  }

  static usePlanImportApi() {
    const api = (planId: string, url: string) =>
      HttpService.axios({
        method: "POST",
        url: `/project_work_plan/detail/import`,
        data: { url },
      });
    return HttpService.useRequest<PlanImportResp>(api);
  }

  static usePlanExportApi() {
    const api = (planId: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project_work_plan/${planId}/detail/export`,
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }
  // 获取第三方节假日信息，中台使用的第三方就是这个
  static useHolidaysApi() {
    const api = () =>{
    
      return  HttpService.axios({
        method: "POST",
        url: `/common_api/holidays/date/list`,
      });
    }
     
    return HttpService.useRequest<ExportResp>(api, { isOutError: true,
       setStore:(data) => {
        
        store.commit("holidays/SET_holidays",data.legalHolidaysList);
        store.commit("holidays/SET_workdays",data.supplementaryWorkList);
        
        console.log("🚀 ~ file: plan-table.service.ts:73 ~ PlanTableService ~ useHolidaysApi ~ data:", store?.state?.holidays?.holidays)
      } });
  }
}
